import { DefectSettingsData } from 'src/lib/fliko/models/defects/defect-settings.data';
import {
  EstateSubcontractorData,
  NamedContact,
  DefectTypeContact,
  SubcontractorContractData
} from 'src/lib/fliko/models/estate/subcontractor.data';
import { LocalizationHelper } from 'src/app/shared/helpers/localization.helper';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { SubcontractorLocalData } from '../services/models/subcontractor.view.model';

export class SubcontractorsHelper {
  public static getMainContact(
    subcontractor: EstateSubcontractorData | SubcontractorLocalData,
    ls: LocalizationService
  ): NamedContact | null {
    return subcontractor.mainContact
      ? { name: ls.translate('label.contactData').toLocaleUpperCase(), ...subcontractor.mainContact }
      : null;
  }

  public static getDedicatedContacts(
    subcontractor: EstateSubcontractorData | SubcontractorLocalData | undefined
  ): DefectTypeContact[] {
    return (subcontractor?.types || []).filter((type) => type.email || type.phone);
  }

  public static getDedicatedContactsNamed(
    subcontractor: EstateSubcontractorData | SubcontractorLocalData | undefined,
    defectSettings: DefectSettingsData,
    ls: LocalizationService
  ): NamedContact[] {
    const lh = new LocalizationHelper(ls);
    return SubcontractorsHelper.getDedicatedContacts(subcontractor).map((x) => {
      const type = defectSettings.defectType.find((t) => t.id == x.typeId);
      return { ...x, name: type ? lh.localizeType(type) : x.typeId };
    });
  }

  public static getDefectTypes(
    subcontractor: EstateSubcontractorData | SubcontractorLocalData | undefined,
    defectSettings: DefectSettingsData,
    ls: LocalizationService
  ): string[] {
    const lh = new LocalizationHelper(ls);
    return subcontractor?.types
      ? subcontractor.types.map((value) => {
          const type = defectSettings.defectType.find((t) => t.id == value.typeId);
          return type ? lh.localizeType(type) : value.typeId;
        })
      : [];
  }

  /**
   * Used to sort contracts; comparison order:
   * 1) definite > indefinite
   * 2) end date
   * 3) start date
   * 4) amount
   * @param {SubcontractorContractData} x
   * @param {SubcontractorContractData} y
   * @return {number}
   */
  public static contractDateCmp(x: SubcontractorContractData, y: SubcontractorContractData): number {
    let value: number;
    if (x.indef) {
      value = y.indef ? x.startDate - y.startDate : 1;
    } else {
      value = y.indef ? -1 : x.endDate! - y.endDate!;
      if (!value) value = x.startDate - y.startDate;
    }
    return value || x.amount - y.amount;
  }
}
